import i18n from "../i18n";
import * as yup from "yup";
import { yupResolver as hookformYupResolver } from "@hookform/resolvers/yup";
import { FieldValues, Resolver } from "react-hook-form";

export function max2DecimalPlacesValidationFunction(yupContext: yup.TestContext<unknown>, value: string | number | undefined | null) {
    const regex = /[.,]\d{3,}$/g;
    if (value && regex.test(value.toString())) {
        return yupContext.createError({
            path: yupContext.path,
            message: i18n.t("validation.numberMaxDecimalPlaces", { n: 2 }).toString(),
        });
    }
    return true;
}

export const nullableNumberSchema = yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable();

/**
 * yupResolver s typem hodnot podle formuláře (useForm<T>).
 * @hookform/resolvers v5 odvozuje typ hodnot formuláře ze schématu, formuláře v TaxGuru ale mají typ daný DTO
 * a schémata jsou netypovaná yup.object({...}), proto se výsledek typuje podle formuláře.
 */
export const yupResolver = <T extends FieldValues>(
    schema: yup.AnyObjectSchema | yup.Lazy<yup.AnyObjectSchema>,
    schemaOptions?: Parameters<yup.AnyObjectSchema["validate"]>[1]
): Resolver<T> => hookformYupResolver(schema as yup.AnyObjectSchema, schemaOptions) as unknown as Resolver<T>;
